export default __webpack_public_path__ + "static/media/bg3.f2911cd2.jpg";